import { Injectable, OnInit, Output } from "@angular/core";
import { Observable, Subject, Subscription } from "rxjs";
import { EstatusJSON } from "../../../../shared/models/EstatusJSON";
import { LocationsAPIService } from "../../../../shared/services/API/LocationsAPI.service";
import { VirtualLocationsAPIService } from "../../../../shared/services/API/VirtualLocationsAPI.service";
import { VirtualLocationDTO } from "../../../ui/organisms/route-sheet/models/VirtualLocationDTO";
@Injectable({
  providedIn: "root",
})
export class VirtualLocationsService implements OnInit {

  private isLoading: boolean = false;
  private isLoading$: Subject<boolean> = new Subject();
  
  constructor(private virtualLocationService: VirtualLocationsAPIService) {
  }

  ngOnInit() {
    
  }

  
  setLoading(resp) {
    this.isLoading$.next(resp);
  }

  getLoading() {
    return this.isLoading$.asObservable();
  }


 
  getLocationCategoryChilds(parentIdentifier: string) {
    return this.virtualLocationService.getLocationCategoryChilds(parentIdentifier);
  }

  getChilds(parentIdentifier: string, idLocationCategoryChild: number):any{
    return this.virtualLocationService.getChilds(parentIdentifier, idLocationCategoryChild);
  }

  getChildrenFilteredByIdentifier(parentIdentifier, searchValue, childCategory){
    return this.virtualLocationService.getChildrenFilteredByIdentifier(parentIdentifier, searchValue, childCategory);
  }

  getProspectsList(identifier: string, idLocationCategory: number, filter: string, includeGeojson: boolean, calculateByDistance: boolean, isForcedReload: boolean) {
    return this.virtualLocationService.getProspectsList(identifier, idLocationCategory, filter, includeGeojson, calculateByDistance, isForcedReload);
  }

  createOrUpdateVirtualLocation(virtualLocationDTO: VirtualLocationDTO) {
    return this.virtualLocationService.createOrUpdateVirtualLocation(virtualLocationDTO);
  }

  createOrUpdateProspectLocation(virtualLocationDTO: VirtualLocationDTO, idLocationCategoryStatus: number) {
    return this.virtualLocationService.createOrUpdateProspectLocation(virtualLocationDTO, idLocationCategoryStatus);
  }
}
